import React from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Scatter } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip, Legend);

export const options = {
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

const labels = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const data = {
  datasets: [
    {
      label: 'A Indigenes',
      data: Array.from({ length: 100 }, () => ({
        x: faker.datatype.number({ min: 0, max: 1000 }),
        y: faker.datatype.number({ min: 0, max: 1000 }),
      })),
      backgroundColor: 'rgba(255, 99, 132, 1)',
    },
    {
      label: 'B Citizens',
      data: Array.from({ length: 100 }, () => ({
        x: faker.datatype.number({ min: 0, max: 1000 }),
        y: faker.datatype.number({ min: 0, max: 100 }),
      })),
      backgroundColor: 'rgba(256, 223, 890, 1)',
    },
  ],
};

export function ScatterChart() {
  return <Scatter options={options} data={data} />;
}
